import {Component, OnInit} from '@angular/core';
import {UnidadesService} from "./unidades.service";
import {UnidadesModel} from "./unidades.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-unidades',
  templateUrl: './unidades.component.html'
})
export class UnidadesComponent extends Components implements OnInit {

  unidades: UnidadesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private unidadesService: UnidadesService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'unidades'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.unidadesService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.unidades = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.unidades);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(unidade) {
    let unidades = this.unidades;
    let unidadesService = this.unidadesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarUnidade')+unidade.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(unidades);
        }

        let index = unidades.indexOf(unidade);
        unidades.splice(index, 1);

        unidadesService.apagar(unidade.id_unidade)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.unidades = unidades;
            },
            err => {
              // Revert the view back to its original state
              unidades.splice(index, 0, unidade);
              self.unidades = unidades;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.unidadesService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.unidades = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/unidades/unidades.component.ts